<template>
  <div>
    <base-toolbar :title="$t('CONTACT_US')"></base-toolbar>
    <v-container fluid class="pt-0">
      <v-row justify="center" class="d-none d-sm-flex page-title">
        <v-col cols="12" md="8">
          {{ $t("CONTACT_US") }}
        </v-col>
      </v-row>
      <v-row justify="center" class="border-t">
        <v-col cols="12" md="8">
          <p class="mt-9 pl-3">
            <v-icon color="primary">{{ mdiPhone }}</v-icon>
            <span class="pl-2">
              <a :href="`tel:${contact_phone}`">{{ contact_phone }}</a>
            </span>
          </p>
          <p class="pl-3">
            <v-icon color="primary">{{ mdiEmail }}</v-icon>
            <span class="pl-2">
              <a :href="`mailto:${contact_email}`">{{ contact_email }}</a>
            </span>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import urls from "@/app-js/urls.js";
import messages from "@/app-js/messages.js";
import { mdiPhone, mdiEmail } from "@mdi/js";

export default {
  components: {
    BaseToolbar: () => import("@/components/BaseToolbar")
  },

  metaInfo: {
    title: "Contact Us",
    meta: [
      {
        vmid: "description",
        name: "description",
        content: undefined
      }
    ]
  },

  data() {
    return {
      mdiPhone,
      mdiEmail,
      name: "",
      messages: "",
      contact_phone: "",
      contact_email: "",
      rules: {
        nameRule: [v => !!v || messages.FULLNAME_ERROR],
        msgRule: [v => !!v || messages.MESSAGE_ERROR]
      }
    };
  },

  async prefetch() {
    await this.fetchContactDetails();
  },

  methods: {
    async fetchContactDetails() {
      const url = urls.MASTER_CONTACT_US;
      const response = await this.$axios.get(url);
      this.contact_phone = response.data.support_contact_phone;
      this.contact_email = response.data.support_contact_email;
    }
  }
};
</script>
